import { AddManualAttendanceListData } from "../data/AddManualAttendanceList.Data";
import { CPDEventData, CommitteeCpdApprovalData } from "../data/CpdEvent.data";
import { CommitteeApprovalData, CreateGMPCourseData, StaffApprovalData } from "../data/CreateGMPCourse.Data"
import { EditGMPCourseData } from "../data/EditGMPCourse.Data";
import { GMPCourseFormData } from "../data/GMPCourseForm.Data";

export const setFieldParameter = ( apiResponse, CourseProviderStatusId ) =>
{
    CreateGMPCourseData.initialState.organisationName = apiResponse?.organisationName;
    CreateGMPCourseData.initialState.UENNumber = apiResponse?.uenNumber;
    CreateGMPCourseData.initialState.mailingAddress1 = apiResponse?.mailingAddressLine1;
    CreateGMPCourseData.initialState.mailingAddress2 = apiResponse?.mailingAddressLine2;
    CreateGMPCourseData.initialState.country = apiResponse?.countryId;
    CreateGMPCourseData.initialState.postalCode = apiResponse?.postalCode;
    CreateGMPCourseData.initialState.organisationWebsite = apiResponse?.organisationWebsite;
    CreateGMPCourseData.initialState.organisationLogo = apiResponse?.organisationLogoName;
    CreateGMPCourseData.initialState.shortDescriptionofOrganisation = apiResponse?.descriptionOfOrganisation;
    CreateGMPCourseData.initialState.organizationfalls = apiResponse?.isGovt ? "yes" : "no";
    CreateGMPCourseData.initialState.nameofRepresentative = apiResponse?.nameOfRepresentative;
    CreateGMPCourseData.initialState.emailAddress = apiResponse?.emailAddress;
    CreateGMPCourseData.initialState.contactNumber = apiResponse?.contactNumber;
    CreateGMPCourseData.initialState.alternateNameOfRepresentative = apiResponse?.alternateNameOfRepresentative;
    CreateGMPCourseData.initialState.alternateEmailAddress = apiResponse?.alternateEmailAddress;
    CreateGMPCourseData.initialState.alternateContactNumber = apiResponse?.alternateContactNumber;
}

export const setCourseFieldParameter = ( apiResponse ) =>
{
    EditGMPCourseData.initialState.organisationName = apiResponse?.organisationName;
    EditGMPCourseData.initialState.UENNumber = apiResponse?.uenNumber;
    EditGMPCourseData.initialState.mailingAddress1 = apiResponse?.mailingAddressLine1;
    EditGMPCourseData.initialState.mailingAddress2 = apiResponse?.mailingAddressLine2;
    EditGMPCourseData.initialState.country = apiResponse?.countryId;
    EditGMPCourseData.initialState.postalCode = apiResponse?.postalCode;
    EditGMPCourseData.initialState.organisationWebsite = apiResponse?.organisationWebsite;
    EditGMPCourseData.initialState.organisationLogo = apiResponse?.organisationLogoName;
    EditGMPCourseData.initialState.shortDescriptionofOrganisation = apiResponse?.descriptionOfOrganisation;
    EditGMPCourseData.initialState.nameofRepresentative = apiResponse?.nameOfRepresentative;
    EditGMPCourseData.initialState.emailAddress = apiResponse?.emailAddress;
    EditGMPCourseData.initialState.contactNumber = apiResponse?.contactNumber;
    EditGMPCourseData.initialState.alternateNameOfRepresentative = apiResponse?.alternateNameOfRepresentative;
    EditGMPCourseData.initialState.alternateEmailAddress = apiResponse?.alternateEmailAddress;
    EditGMPCourseData.initialState.alternateContactNumber = apiResponse?.alternateContactNumber;
}

export const setCpdFieldParameter = ( apiResponse ) =>
{
    const updatedFormData = HideShowChooseEvent( apiResponse?.isApplicationRunNew ? "New" : "Rerun" );
    if ( updatedFormData )
    {
        CPDEventData.initialState.applicationRun = apiResponse?.isApplicationRunNew ? "New" : "Rerun";
        CPDEventData.initialState.chooseEvent = apiResponse?.approveCPDEventTypeId;
        CPDEventData.initialState.relatedEvent = apiResponse?.relatedEventTitle;
        CPDEventData.initialState.typeOfEvent = apiResponse?.cpdEventTypeId;
        CPDEventData.initialState.eventCompetencies = apiResponse?.cpdEventCompetenciesId?.split( "," )?.map( Number );;
        CPDEventData.initialState.eventTitle = apiResponse?.eventTitle;
        CPDEventData.initialState.eventSynopsis = apiResponse?.eventSynopsis;
        CPDEventData.initialState.eventURL = apiResponse?.eventUrl;
        CPDEventData.initialState.registrationURLorEmailAddress = apiResponse?.registrationUrlOrEmail;
        CPDEventData.initialState.eventProgrammeFile = apiResponse?.eventProgremmeFilename;
        CPDEventData.initialState.speakersCVSFile = apiResponse?.speakerCVFilename;
        CPDEventData.initialState.additionalRemarks = apiResponse?.additionRemarks;
        CPDEventData.initialState.eventVenue = apiResponse?.eventVenue;
        CPDEventData.initialState.eventAddress = apiResponse?.venueAddress;
        CPDEventData.initialState.postalCode = apiResponse?.postalCode;
        CPDEventData.initialState.standardOrNonMember = apiResponse?.standardOrNonMemberFees;
        CPDEventData.initialState.member = apiResponse?.memberFees;
        CPDEventData.initialState.nameOfRepresentative = apiResponse?.nameOfRepresentative;
        CPDEventData.initialState.contactNumber = apiResponse?.contactNumber;
        CPDEventData.initialState.emailAddress = apiResponse?.emailAddress;
        CPDEventData.initialState.nameofAlternateRepresentative = apiResponse?.alternateNameOfRepresentative;
        CPDEventData.initialState.alternateContactNumber = apiResponse?.alternateContactNumber;
        CPDEventData.initialState.alternateEmailAddress = apiResponse?.alternateEmailAddress;
        CPDEventData.initialState.startDate = apiResponse?.scheduleStartDate;
        CPDEventData.initialState.endDate = apiResponse?.scheduleEndDate;
        CPDEventData.initialState.startTime = apiResponse?.scheduleStartTime;
        CPDEventData.initialState.endTime = apiResponse?.scheduleEndTime;
        CPDEventData.initialState.totalContactHours = apiResponse?.totalContactHours;
        CPDEventData.initialState.cpdPoints = apiResponse?.cpdPoints == 0 ? 0 :apiResponse?.cpdPoints;
    }
}

export const setFieldParameterForStaffCommittee = ( apiResponse ) =>
{
    StaffApprovalData.initialState.internalComments = apiResponse?.staffApprovalInternalNotes;
    StaffApprovalData.initialState.sendforCommitteeApproval = apiResponse?.sentForCommitteeApproval ? true : false;
    CommitteeApprovalData.initialState.internalComments = apiResponse?.committeeApprovalInternalNotes;
}

export const setFieldParameterForCpdStaffCommittee = ( apiResponse ) =>
{
    StaffApprovalData.initialState.internalComments = apiResponse?.staffApprovalInternalNotes;
    StaffApprovalData.initialState.sendforCommitteeApproval = apiResponse?.sentForCommitteeApproval ? true : false;
    CommitteeCpdApprovalData.initialState.internalComments = apiResponse?.committeeApprovalInternalNotes;
    CommitteeCpdApprovalData.initialState.finalCpdPoints = apiResponse?.finalCpdPoint;
}

export const setAllDropDownField = ( apiResponse ) =>
{
    const filterDropDownList = ( dropdownName ) =>
    {
        return apiResponse.reduce( ( acc, item ) =>
        {
            if ( item.dropdownName === dropdownName )
            {
                acc.push( {
                    value: item.id,
                    label: item.name,
                } );
            }
            return acc;
        }, [] );
    }

    const dropdownLists = {
        "country": filterDropDownList( "Nationality" ),
        "typeOfEvent": filterDropDownList( "Cpd Event Type" ),
        "eventCompetencies": filterDropDownList( "Cpd Event Competencies" ),
        "statusId": filterDropDownList( "Course Provider Status" ),
        "sourceId": filterDropDownList( "Course Event" ),
        // "courseId": filterDropDownList("Approved Course Provider"),
        // "eventId": filterDropDownList("Approve Cpd Event By Course Provider"),
    };

    const formFields = [
        ...CreateGMPCourseData.formFields,
        ...CPDEventData.formFields,
        ...GMPCourseFormData.formFields,
        ...EditGMPCourseData.formFields
        // ...AddManualAttendanceListData.formFields
    ];

    formFields.forEach( field =>
    {
        const dropdownList = dropdownLists[ field?.id ];
        if ( dropdownList )
        {
            field.fieldSetting.options = dropdownList;
        }
    } );
};

export const setAllDropDownFields = ( apiResponse, mode ) =>
{
    const filterDropDownList = ( dropdownName ) =>
    {
        return apiResponse.reduce( ( acc, item ) =>
        {
            if ( item.dropdownName === dropdownName )
            {
                acc.push( {
                    value: item.id,
                    label: item.name,
                } );
            }
            return acc;
        }, [] );
    }
    let dropdownLists = {
        "courseId": filterDropDownList( "Approved Course Provider" ),
    };
    if ( mode === 'event' )
    {
        dropdownLists = {
            "eventId": filterDropDownList( "Approve Cpd Event By Course Provider" ),
        };
    }

    const formFields = [
        ...AddManualAttendanceListData.formFields
    ];

    formFields.forEach( field =>
    {
        const dropdownList = dropdownLists[ field?.id ];
        if ( dropdownList )
        {
            field.fieldSetting.options = dropdownList;
        }
    } );
    return { ...AddManualAttendanceListData, formFields: formFields }
};

const defaultCss = "col-lg-6 col-12 mb-3";
const hiddenCss = "col-lg-6 col-12 mb-3 d-none";

export const HideShowChooseEvent = ( value ) =>
{
    const companyNameIndex = CPDEventData.formFields.findIndex( field => field.id === "chooseEvent" );
    const relatedEventIndex = CPDEventData.formFields.findIndex( field => field.id === "relatedEvent" );
    const additionalButtonIndex = CPDEventData.formFields.findIndex( field => field.id === "additionalButton" );
    const css = value === "Rerun" ? defaultCss : hiddenCss;
    const validate = value === "Rerun" ? [ { type: "require" } ] : [];

    if ( companyNameIndex == 2 && relatedEventIndex == 3 && additionalButtonIndex == 4 )
    {
        const updatedFormData = {
            ...CPDEventData,
            formFields: CPDEventData.formFields.map( field => ( { ...field } ) )
        };

        updatedFormData.formFields[ companyNameIndex ].style.containerCss = css;
        updatedFormData.formFields[ companyNameIndex ].validation = validate;
        updatedFormData.formFields[ relatedEventIndex ].style.containerCss = css;
        updatedFormData.formFields[ additionalButtonIndex ].style.containerCss = css;

        return updatedFormData;
    } else
    {
        console.error( "Field not found." );
        return false;
    }
};

export const setDropDownField = ( apiResponse ) =>
{
    const filterDropDownList = ( dropdownName ) =>
    {
        return apiResponse.reduce( ( acc, item ) =>
        {
            if ( item.dropdownName === dropdownName )
            {
                acc.push( {
                    value: item.id,
                    label: item.name,
                } );
            }
            return acc;
        }, [] );
    }

    const dropdownLists = {
        "chooseEvent": filterDropDownList( "Approve Cpd Event" ),
        "relatedEvent": filterDropDownList( "Related Event Type" ),
    };

    const formFields = [ ...CPDEventData.formFields ];

    formFields.forEach( field =>
    {
        const dropdownList = dropdownLists[ field?.id ];
        if ( dropdownList )
        {
            field.fieldSetting.options = dropdownList;
        }
    } );
};
